import styled$2 from '@emotion/styled';

const styled = styled$2;
var styled$1 = styled;

export { styled as a, styled$1 as s };
